import React, { useState } from "react";

import { TabContainer } from "../sub_components/Tabs";
import MainLayout from "../layouts/Main";
import { SVGIcon } from "../wrappers/SVGIcon";

import { useGetSubscribedModuleFeatures } from "../../hooks/subscribed_module_features";
import { useGetUserDetails } from "../../hooks/users";

import { ModuleFeatureValueType } from "../../interfaces/types";

import { Icons } from "../../data/Assets";

const SettingsPage = () => {
    const tabItems = [
        { id: "account", label: "Account" },
        { id: "module_features", label: "Module Features" },
        { id: "other", label: "Other", disabled: true },
    ];

    const [currentTab, setCurrentTab] = useState<string>("account");

    const handleTabChange = (tabId: string) => {
        setCurrentTab(tabId);
    };

    return (
        <MainLayout>
            <div className="immersion__page_view">
                <h2 className="immersion__color__dark mb_20">Settings</h2>
                <TabContainer
                    items={tabItems}
                    activeTab={currentTab}
                    onChange={handleTabChange}
                    variant="navigation"
                />
                <div className="immersion__settings__page__content">
                    {currentTab === "account" && <AccountDetailsView />}
                    {currentTab === "module_features" && <ModuleFeaturesView />}
                </div>
            </div>
        </MainLayout>
    );
};

export default SettingsPage;

const AccountDetailsView = () => {
    const { data: userDetails } = useGetUserDetails();

    return (
        <div className="immersion__settings__page__account_details_view">
            <h3>Account Details</h3>
            <div className="immersion__settings__page__account_details_view__content">
                <div className="immersion__settings__page__account_details_view__content__item">
                    <p><strong>Name:</strong></p>
                    <p>{userDetails?.name}</p>
                </div>
                <div className="immersion__settings__page__account_details_view__content__item">
                    <p><strong>Email:</strong></p>
                    <p>{userDetails?.email}</p>
                </div>
                {!!userDetails?.phone &&
                    <div className="immersion__settings__page__account_details_view__content__item">
                        <p><strong>Phone:</strong></p>
                        <p>{userDetails?.phone}</p>
                    </div>
                }
                <div className="immersion__settings__page__account_details_view__content__item">
                    <p><strong>Role:</strong></p>
                    <p>{userDetails?.role ? userDetails?.role.replace('_', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'}</p>
                </div>
            </div>
        </div>
    );
};

const ModuleFeaturesView = () => {
    const [openAccordionIdx, setOpenAccordionIdx] = useState<number[]>([]);

    const { data: subscribedModuleFeatures, isLoading } = useGetSubscribedModuleFeatures();

    const toggleAccordion = (idx: number) => {
        if (openAccordionIdx.includes(idx)) {
            setOpenAccordionIdx(prev => prev.filter(id => id !== idx));
        } else {
            setOpenAccordionIdx(prev => [...prev, idx]);
        }
    };

    return (
        <div className="immersion__settings__page__module_features_view">
            {isLoading &&
                <div className='immersion__school__module_features__loader'>
                    <span className='immersion__list_loader' />
                    <p>Loading features</p>
                </div>
            }
            {!isLoading && !subscribedModuleFeatures?.length &&
                <div className='immersion__school__module_features__no_features'>
                    <h4>No features found</h4>
                    <p>Features will be displayed here.</p>
                </div>
            }
            {!!subscribedModuleFeatures?.length &&
                <div className='immersion__school__module_features__list'>
                    {subscribedModuleFeatures.map((feature, index) => {
                        const isOpen = openAccordionIdx.includes(index);
                        let title = feature.type.replace('-', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                        return (
                            <button
                                key={feature.id}
                                className={`immersion__school__module_features__list__accordion ${openAccordionIdx.includes(index) ? 'immersion__school__module_features__list__accordion__open' : ''}`}
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className="immersion__school__module_features__list__accordion__header">
                                    <h5 className="immersion__color__dark">{title}</h5>
                                    <SVGIcon src={Icons.Chevron} rotation={isOpen ? 180 : 0} color='primary' />
                                </div>
                                {isOpen &&
                                    <div className="immersion__school__module_features__list__accordion__content">
                                        {feature.module_features.map(moduleFeature => {
                                            const isSelf = moduleFeature.title.replace(' ', '').toLowerCase().includes(title.replace(' ', '').toLowerCase());

                                            return (
                                                <div key={moduleFeature.id} className="immersion__school__module_features__list__accordion__content__item">
                                                    <p>{isSelf ? 'Included' : moduleFeature.title}</p>
                                                    {moduleFeature.value_type === ModuleFeatureValueType.BOOLEAN &&
                                                        <>
                                                            {moduleFeature.subscribed_module_feature?.value === 'true'
                                                                ? <SVGIcon src={Icons.CheckCircle} color='success' />
                                                                : <SVGIcon src={Icons.ExclamationCircle} color='error' />
                                                            }
                                                        </>
                                                    }
                                                    {moduleFeature.value_type === ModuleFeatureValueType.INTEGER &&
                                                        <p><strong>{moduleFeature.subscribed_module_feature?.value ?? '0'}</strong></p>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                            </button>
                        )
                    })}
                </div>
            }
        </div>
    );
};
